import { useGetOverviewMetrics } from 'Deer/hooks/dataHooks/metrics/useGetOverviewMetrics';
import { useSelectVisierAuthToken } from 'Deer/slice/UserAccessesSlice';
import { format } from 'date-fns';

export const useCompanyOneOnOneOverviewMetricCards = () => {
  const currentDate = new Date();

  const formattedDate = format(currentDate, 'yyyy-MM-dd');
  const visierAuthToken = useSelectVisierAuthToken();

  const { data: cardsDataApi } = useGetOverviewMetrics<
    [
      'ONE_ON_ONE_COMPLETION_PERCENTAGE_AVERAGE_KPI',
      'MANAGER_COUNT_NO_OOOS_WITH_REPORTS',
      'ONE_ON_ONE_SATISFACTION_SCORE_AVERAGE_KPI',
    ]
  >({
    metrics: [
      {
        analyticsType: 'ONE_ON_ONE_V2',
        metricType: 'ONE_ON_ONE_COMPLETION_PERCENTAGE_AVERAGE_KPI',
        params: {
          mock: false,
          time: {
            endDate: formattedDate,
            intervalCount: 1,
            periodCount: 1,
            periodType: 'MONTH',
          },
          token: visierAuthToken,
        },
      },
      {
        analyticsType: 'ONE_ON_ONE_V2',
        metricType: 'ONE_ON_ONE_SATISFACTION_SCORE_AVERAGE_KPI',
        params: {
          mock: false,
          time: {
            endDate: formattedDate,
            intervalCount: 1,
            periodCount: 1,
            periodType: 'MONTH',
          },
          token: visierAuthToken,
        },
      },
      {
        analyticsType: 'ONE_ON_ONE_V2',
        metricType: 'MANAGER_COUNT_NO_OOOS_WITH_REPORTS',
      },
    ],
    cohortId: -1,
  });

  return cardsDataApi;
};
